import { ElMessage, ElMessageBox } from 'element-plus';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';

export function elemsg(param){
	return ElMessage(param);
}

export function elealert(param){
	return ElMessageBox(param);
}

export function eleconfirm(param){
	ElMessageBox.confirm(param);
}